import { render } from "./DigitalWorkplace.vue?vue&type=template&id=2704a83e&scoped=true"
import script from "./DigitalWorkplace.vue?vue&type=script&lang=js"
export * from "./DigitalWorkplace.vue?vue&type=script&lang=js"

import "./DigitalWorkplace.vue?vue&type=style&index=0&id=2704a83e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2704a83e"]])

export default __exports__